import {RouteLink} from "@app/shared/enums/route-link.enum";
import {LabelChange} from "@app/shared/classes/label-change";

export const DefaultDaysForDataLoad = 30;           // default number of days to load initial data
export const DefaultDayRangeForSearch = [           // default day range for search
  {label: '30', value: '30'},
  {label: '60', value: '60'},
  {label: '90', value: '90'},
  {label: '90+', value: '-1'}];

export const LargeDialogWidth = 600;
export const MidDialogWidth = 400;
export const SmallDialogWidth = 100;
export const GlobalSearchDTSize = 40;

export const DialogStyle40 = {'width':'40vw','max-width':'600px'};
export const DialogStyle65 = {'width':'65vw','max-width':'900px'};
export const DialogStyle90 = {'width':'90vw','max-width':'1200px'};

export const DialogStyle100 = {width: '15vw'};
export const DialogStyle200 = {width: '25vw'};
export const DialogStyle300 = {width: '40vw'};
export const DialogStyle400 = {'width':'40vw'};
export const DialogStyle425 = {width: '40vw'};
export const DialogStyle450 = {width: '40vw'};
export const DialogStyle460 = {width: '40vw'};
export const DialogStyle480 = {width: '40vw'};
export const DialogStyle500 = {width: '40vw'};
export const DialogStyle550 = {width: '40vw'};
export const DialogStyle600 = {width: '75vw'};
export const DialogStyle700 = {width: '75vw'};
export const DialogStyle750 = {width: '75vw'};
export const DialogStyle800 = {width: '75vw'};
export const DialogStyle850 = {width: '75vw'};
export const DialogStyle900 = {width: '75vw'};
export const DialogStyle950 = {width: '75vw'};
export const DialogStyle1000 = {width: '75vw'};
export const DialogStyle1200 = {width: '75vw'};
export const DialogStyle200x300 = {width: '50vw',height: '70vw'};
export const DialogStyle400x300 = {width: '50vw',height: '70vw'};
export const DialogStyle400x350 = {width: '50vw',height: '70vw'};
export const DialogStyle400x450 = {width: '50vw',height: '70vw'};
export const DialogStyle400x500 = {width: '50vw',height: '70vw'};
export const DialogStyle400x600 = {width: '50vw',height: '70vw'};
export const DialogStyle400x700 = {width: '50vw',height: '70vw'};
export const DialogStyle425x500 = {width: '50vw',height: '70vw'};
export const DialogStyle425x525 = {width: '50vw',height: '70vw'};
export const DialogStyle425x600 = {width: '50vw',height: '70vw'};
export const DialogStyle425x625 = {width: '50vw',height: '70vw'};
export const DialogStyle425x650 = {width: '50vw',height: '70vw'};
export const DialogStyle425x700 = {width: '50vw',height: '70vw'};
export const DialogStyle450x525 = {width: '50vw',height: '70vw'};
export const DialogStyle450x300 = {width: '50vw',height: '70vw'};
export const DialogStyle450x500 = {width: '50vw',height: '70vw'};
export const DialogStyle450x550 = {width: '50vw',height: '70vw'};
export const DialogStyle450x600 = {width: '50vw',height: '70vw'};
export const DialogStyle450x650 = {width: '50vw',height: '70vw'};
export const DialogStyle450x675 = {width: '50vw',height: '70vw'};
export const DialogStyle450x725 = {width: '50vw',height: '70vw'};
export const DialogStyle450x750 = {width: '50vw',height: '70vw'};
export const DialogStyle450x900 = {width: '50vw',height: '70vw'};
export const DialogStyle500x200 = {width: '50vw',height: '70vw'};
export const DialogStyle500x300 = {width: '50vw',height: '70vw'};
export const DialogStyle500x650 = {width: '50vw',height: '70vw'};
export const DialogStyle500x725 = {width: '50vw',height: '70vw'};
export const DialogStyle550x550 = {width: '50vw',height: '70vw'};
export const DialogStyle550x650 = {width: '50vw',height: '70vw'};
export const DialogStyle600x400 = {width: '50vw',height: '70vw'};
export const DialogStyle600x450 = {width: '50vw',height: '70vw'};
export const DialogStyle600x500 = {width: '50vw',height: '70vw'};
export const DialogStyle800x600 = {width: '50vw',height: '70vw'};
export const DialogStyle930x600 = {width: '50vw',height: '70vw'};
export const DialogStyle1000x600 = {width: '50vw',height: '70vw'};
export const DialogStyle1200x600 = {width: '50vw',height: '70vw'};

export const RowsInDashboardWidgetDT = 3;
export const DefaultRowsDT = 10;
export const RowsPerPageDT = [10, 25, 50];

export const RowsInLargeDT = 30;

export const RowsPerPageLargeDT = [10, 50, 100];

export const TextareaDefaultRow = 5;
export const TextareaDefaultColumn = 30;

export const UsZipCodePattern = /^\d{5,5}(-\d{4,4})?$/;
export const PatternFor2Digits = '^[0-9]{1,2}$';
export const PatternFor5DigitsDecimal = '^[0-9.]{1,5}$';
export const PatternFor3Digits = '^[0-9]{1,3}$';
export const PatternFor5Digits = '^[0-9]{1,5}$';
export const PatternFor5Digits2Decimal = '/^(\d{1,5})(\.\d{1,2})?/';
export const PatternForPercentAnd2Decimal = '[0-9]{1}(\.\d{1,2})?$|^[0-9]{1}[0-9]{1}(\.\d{1,2})?$|^100$"';
export const PatternForWebsiteURL = '^((https?|ftp|smtp)://)?(www.)?[a-z0-9]+\.[a-z0-9]+\.?[a-z0-9]+\.?[a-z0-9]+\.?[a-z]+(\/[a-zA-Z0-9#]+\/?)*$';

export const AlphaNumRegex = /^[\.0-9a-zA-Z]+$/;
export const AlphaNumDashRegex = /^[a-zA-Z0-9-]+$/;

export const YearRange = '2000:2040';                     // AnnualUpdateRequired - review and update annually
export const AccountingYearRange = '2020:2024';           // AnnualUpdateRequired - review and update annually
export const BirthYearRange = '1920:2010';                // AnnualUpdateRequired - review and update annually
export const DependentBirthYearRange = '1920:2023';       // AnnualUpdateRequired - review and update annually
export const CredentialYearRange = '1970:2023';           // AnnualUpdateRequired - review and update annually
export const EffectiveYearRange = '1900:2100';
export const MillisecondsInOneDay = 86400000;
export const PerDiemRatioFirstAndLastDay = 0.75;

export const BreadcrumbMain = {icon: 'pi pi-home', routerLink: RouteLink.Home};
export const BreadcrumbHR = {label: 'HR Services', routerLink: RouteLink.HR};
export const BreadcrumbServices = {label: 'Services', routerLink: RouteLink.Services};
export const BreadcrumbESS = {label: 'Employee Self-Service', routerLink: RouteLink.ESS};
export const BreadcrumbMSS = {label: 'Manager Self-Service', routerLink: RouteLink.MSS};
export const BreadcrumbRecruitToHire = {label: 'Recruit-to-Hire', routerLink: RouteLink.RecruitToHire};
export const BreadcrumbFinance = {label: 'Finance', routerLink: RouteLink.Finance};
export const BreadcrumbAP = {label: 'Account Payable', routerLink: RouteLink.AccountPayable};
export const BreadcrumbAR = {label: 'Account Receivable', routerLink: RouteLink.AccountReceivable};
export const BreadcrumbChargeCodeAdmin = {label: 'Charge Code Admin', routerLink: RouteLink.ChargeCodeAdmin};
export const BreadcrumbAccountGroup = {label: 'Account Group', routerLink: RouteLink.AccountGroup};
export const BreadcrumbAccountMapping = {label: 'Account Mapping', routerLink: RouteLink.AccountMapping};
export const BreadcrumbProcurement = {label: 'Procurement', routerLink: RouteLink.Procurement};
export const BreadcrumbOrders = {label: 'Orders', routerLink: RouteLink.OrderMgt};
export const BreadcrumbSolutionMgr = {label: 'Solution Manager', routerLink: RouteLink.SolMgrMain};
export const BreadcrumbSolutionMgrTransactionDataImport = {label: 'Solution Manager Transaction Data Import', routerLink: RouteLink.SolMgrDataImport};
export const BreadcrumbFileSharingOnboardingFiles = {label: 'Onboarding Files', routerLink: RouteLink.FileSharingOnboardingFiles};
export const BreadcrumbFileSharingMaintenanceFiles = {label: 'Maintenance Files', routerLink: RouteLink.FileSharingMaintenanceFiles};
export const BreadcrumbPayroll = {label: 'Payroll', routerLink: RouteLink.Payroll};
export const BreadcrumbPayrollRegister = {label: 'Payroll Register', routerLink: RouteLink.PayrollRegister};
export const BreadcrumbPayeeMain = {label: 'Payee Main', routerLink: RouteLink.PayeeMain};
export const BreadcrumbPayeeDetails = {label: 'Payee Details', routerLink: RouteLink.PayeeDetails};
export const BreadcrumbEstimatesAndProjectsMain = {label: 'Estimates & Projects', routerLink: RouteLink.EstimatesAndProjects};
export const BreadcrumbProjectStatusReport = {label: 'Project Status Reports', routerLink: RouteLink.ProjectStatusReport};

export const BreadcrumbCandidateHome = {label: 'Candidate Home', routerLink: RouteLink.CandidateHome};
export const BreadcrumbCustomerHome = {label: 'Customer Home', routerLink: RouteLink.CustomerHome};
export const BreadcrumbVirtualOrientation = {label: 'Virtual Orientation', routerLink: RouteLink.VirtualOrientation};

export const BreadcrumbCyberPlanSystemSummary = {label: 'System Summary', routerLink: RouteLink.CyberplanSystemsSummary};

export const MonthConstant = {
  Jan: 0,
  Feb: 1,
  Mar: 2,
  Apr: 3,
  May: 4,
  Jun: 5,
  Jul: 6,
  Aug: 7,
  Sep: 8,
  Oct: 9,
  Nov: 10,
  Dec: 11
};

// Make sure to sync with the backend enums
export const NoTitlecaseAccountType = ["COGS"];
export const NoTitlecaseCombinedLeaveType = ["PTO", "FMLA", "LOA", "LWOP"];
export const NoTitleCaseExtendedLeave = ["FMLA", "LOA", "LWOP"];
export const NoTitlecaseApprover = ["CEO", "COO", "CFO", "CIO", "VP", "C**", "HCM", "CLevel"];
export const NoTitlecaseEducationLevel = ["GED"];
export const NoTitlecaseExpenseType = ["UEM", "UENT", "UMISC", "M&IECOMRL"];
export const NoTitlecaseLeaveType = ["PTO"];
export const NoTitlecaseOrgDocType = ["IP", "NDA"];
export const NoTitlecaseOrgPolicyType = ["HR", "IT"];
export const NoTitlecaseOfferLetterClauseType = ["PTO"];
export const NoTitlecaseBusinessAreaType = ["HR"];
export const NoTitlecaseAchBusinessType = ["LLC", "LLP", "LP"];
export const NoTitlecaseInternalContactType = ["HR", "SCA", "FSO", "IT"];
export const NoTitlecaseBillingLevelType = ["CLIN"];
export const NoTitlecaseLicenseType = ["BI"];
export const NoTitlecasePartialTransactionType = ["ESS", "MSS", "QLE"];
export const NoTitlecaseVendorCategory: string[] = ["AWS"];
export const NoTitlecaseShippingType: string[] = ["UPS"];
export const NoTitlecaseCyberplanThreatCategory: string[] = ["DOS"];
export const NoTitlecaseCyberplanConfig: string[] = ["SMB"];

export const LabelChangeTransactionType: LabelChange[] = [
  {label: "ESS_QLE_REQUEST", replace: "ESS QLE Request"},
  {label: "MSS_DEPARTMENT_CHANGE", replace: "MSS Department Change"},
  {label: "MSS_LOCATION_CHANGE", replace: "MSS Location Change"},
  {label: "MSS_POSITION_CHANGE", replace: "MSS Position Change"},
  {label: "MSS_SALARY_CHANGE", replace: "MSS Salary Change"},
  {label: "MSS_STATUS_CHANGE", replace: "MSS Status Change"},
];

export const LabelChangeAddressType: LabelChange[] = [
  {label: "BILL_TO", replace: "Bill-To"}, {label: "SHIP_TO", replace: "Ship-To"},
  {label: "BILL_FROM", replace: "Bill-From"}, {label: "SHIP_TO", replace: "Ship-From"},
  {label: "RETURN_TO", replace: "Return-To"}
];

// Make sure to sync with the backend enums
export const LabelChangeFrameworkCategory: LabelChange[] = [{label: "NIST_800_171", replace: "NIST 800-171"},
  {label: "NIST_800_53", replace: "NIST 800-53"},
  {label: "CMMC_20", replace: "CMMC 2.0"}];

export const LabelChangeShippingType: LabelChange[] = [{label: "FEDEX", replace: "FedEx"}];

export const LabelChangeSolutionCategory: LabelChange[] =
  [{label: "ACCESS_CONTROL_LIST_SOLUTION", replace: "Access Control List (ACL) Solution"},
    {label: "ANTIMALWARE_SOLUTION", replace: "Antimalware Solution"},
    {label: "ANTISPAM_SOLUTION", replace: "Antispam Solution"},
    {label: "APPLICATION_SECURITY_TESTING", replace: "Application Security Testing (DevOps)"},
    {label: "BACKUP_SOLUTION", replace: "Backup Solution (BCDR)"},
    {label: "APPLICATION_CONTROL", replace: "Application Control (allow/deny)"},
    {label: "CENTRALIZED_LOG_MANAGEMENT_SIEM_EVENT_LOG_MONITORING", replace: "Centralized Log Management / SIEM / Event Log Monitoring"},
    {label: "CERTIFICATE_MANAGEMENT_SOLUTION_PUBLIC_KEY_INFRSTRUCTURE", replace: "Certificate Management Solution / Public Key Infrstructure (PKI) (key management)"},
    {label: "CHANGE_CONTROL_SOLUTION", replace: "Change Control Solution"},
    {label: "CONFIGURATION_MANAGEMENT_DATABASE", replace: "Configuration Management Database (CMDB)"},
    {label: "CONTENT_DNS_FILTERING_SOLUTION", replace: "Content / DNS Filtering Solution"},
    {label: "CRYPTOGRAPHIC_SOLUTION", replace: "Cryptographic Solution (data at rest)"},
    {label: "DATA_CLASSIFICATION_SOLUTION", replace: "Data Classification Solution"},
    {label: "DATA_DESTRUCTION_SOLUTION", replace: "Data Destruction Solution"},
    {label: "DATA_LOSS_PREVENTION", replace: "Data Loss Prevention (DLP)"},
    {label: "DISCRETIONARY_ACCESS_CONTROL", replace: "Discretionary Access Control (DAC)"},
    {label: "DOCUMENTATION", replace: "Documentation(policies, standards, procedures, etc.)"},
    {label: "EMAIL", replace: "Email"},
    {label: "EMERGING_THREATS_INTELLIGENCE_FEED", replace: "Emerging Threats (ET) Intelligence Feed"},
    {label: "FILE_INTEGRITY_MONITORING", replace: "File Integrity Monitoring (FIM)"},
    {label: "FORENSIC_SOLUTION", replace: "Forensic Solution"},
    {label: "GOVERNANCE_RISK_COMPLIANCE", replace: "Governance, Risk & Compliance (GRC)"},
    {label: "HUMAN_RESOURCE_MANAGEMENT_SYSTEM", replace: "Human Resource Management System (HRMS)"},
    {label: "IDENTITY_ACCESS_MANAGEMENT", replace: "Identity & Access Management (IAM)"},
    {label: "INCIDENT_RESPONSE_PLAN", replace: "Incident Response Plan (IRP)"},
    {label: "INTRUSION_DETECTION_PREVENTION_SYSTEM", replace: "Intrusion Detection / Prevention System (IDS / IPS)"},
    {label: "IT_ASSET_MANAGEMENT", replace: "IT Asset Management (ITAM)"},
    {label: "LEARNING_MANAGEMENT_SYSTEM", replace: "Learning Management System (LMS)"},
    {label: "MOBILE_DEVICE_MANAGEMENT", replace: "Mobile Device Management (MDM)"},
    {label: "MULTI_FACTOR_AUTHENTICATION", replace: "Multi-Factor Authentication (MFA)"},
    {label: "NETWORK_FIREWALL", replace: "Network Firewall"},
    {label: "NETWORK_BASELINE_MANAGEMENT_SOLUTION", replace: "Network Baseline Management Solution"},
    {label: "NETWORK_TIME_PROTOCOL_MANAGEMENT_SOLUTION", replace: "Network Time Protocol (NTP) Management Solution"},
    {label: "PATCH_MANAGEMENT_SOLUTION", replace: "Patch Management Solution"},
    {label: "PENETRATION_TESTING_SOLUTION", replace: "Penetration Testing Solution"},
    {label: "PHISHING_AWARENESS_CAMPAIGN_SOLUTION", replace: "Phishing Awareness Campaign Solution"},
    {label: "PHYSICAL_ACCESS_CONTROL_SOLUTION", replace: "Physical Access Control (PAC) Solution"},
    {label: "PRIVILEGED_ACCESS_MANAGEMENT", replace: "Privileged Access Management (PAM)"},
    {label: "REMOTE_ACCESS_SOLUTION_VPN_CONCENTRATOR", replace: "Remote Access Solution / VPN Concentrator"},
    {label: "RISK_ASSESSMENT_SOLUTION", replace: "Risk Assessment Solution"},
    {label: "RISK_REGISTER_POAM_SOLUTION", replace: "Risk Register / POA&M Solution"},
    {label: "SANDBOX_DETONATION_CHAMBER_SOLUTION", replace: "Sandbox / Detonation Chamber Solution"},
    {label: "SECURE_BASELINE_CONFIGURATIONS_SOLUTION", replace: "Secure Baseline Configurations (SBC) Solution"},
    {label: "SECURE_FILE_SHARING", replace: "Secure File Sharing"},
    {label: "SESSION_RECORDING_SOLUTION", replace: "Session Recording (logging) Solution"},
    {label: "SECURITY_AUTOMATION_AND_RESPONSE", replace: "Security Orchestration, Automation and Response (SOAR)"},
    {label: "VIRTUAL_DESKTOP_INFRASTRUCTURE", replace: "Virtual Desktop Infrastructure (VDI)"},
    {label: "VISITOR_MANAGEMENT", replace: "Visitor Management"},
    {label: "VULNERABILITY_SCANNING_SOLUTION", replace: "Vulnerability Scanning Solution"},
    {label: "WIRELESS_INTRUSION_PREVENTION_SYSTEM", replace: "Wireless Intrusion Prevention /Detection System (WIPS/WIDS)"}];

export const LabelChangeSolutionSizeCategory: LabelChange[] = [{label: "MICRO_SMALL_BUSINESS_LESS_20_USERS", replace: "Micro-Small Business less than 20 users"},
  {label: "SMALL_BUSINESS_BW_20_200_USERS", replace: "Small Business between 20-200 users"},
  {label: "MEDIUM_BUSINESS_BW_200_500_USERS", replace: "Medium Business between 200-500 users"},
  {label: "LARGE_BUSINESS_BW_500_2000_USERS", replace: "Large Business between 500-2000 users"},
  {label: "ENTERPRISE_BUSINESS_MORE_2000_USERS", replace: "Enterprise Business more than 2000 users"}];

export const LabelChangeInfoCategory: LabelChange[] = [{label: "GFE_TECHNICAL", replace: "GFE Technical"}];

export const LabelChangeLeaveActionType: LabelChange[] = [{label: "BEG_BALANCE", replace: "Beginning Balance"}];

// Math related constants
export const RoundUpDecimalPlace = 2;
export const TaxRateRoundUpDecimalPlace = 5;

export const ChangeDetectionTimeout = 1;

export const BLOB_RESPONSE_TYPE = 'blob' as 'json';

export const DWOLLA_ACCEPTABLE_FILE_TYPES = ".jpg,.jpeg,.png,.pdf";  //Acceptable File types for dwolla
export const DWOLLA_ACCEPTABLE_MAX_FILE_SIZE = 10485760;   //Max file size acceptable by dwolla in bytes (10 MB)

export const EXCLUDE_PREFIX_OBJECT = ["id", "version"];
export const EXCLUDE_PREFIX_PARTNER_ADDRESS = ["id", "version", "addrType"];
export const EXCLUDE_PREFIX_PARTNER_ACH = ["partnerAchDetails"];
export const EXCLUDE_PREFIX_COPY_PARTNER_ADDRESS = ["id", "version", "addrType", "addrName"];

// used to set displayMode when invoking app-file-explorer component
export enum FileExplorerDisplay {
  Dialog = "Dialog",
  FileExplorer = "FileExplorer"
}

export enum DisplayOption {
  NoBreadcrumb = 'NO_BREADCRUMB',
  NoHeader = 'NO_HEADER'
}


// ToDo: we need to think about how to handle this better
export enum DocTypes {
  ExpenseReceipt = 2,
}


export function serializeType<T>(object: T) {
  return function () {
    return object;
  };
}

//P-table column
export class DTColumn {
  field: string;
  header: string;
  subfield?: string;
}

//Internal Use:  To distinguish between project and estimates in routes
export enum ProjectType {
  Project = 'PROJECT',
  ProjectEstimate = 'PROJECT_ESTIMATE',
  Contract = 'CONTRACT'
}

export enum YTDEntityType {
  Project = 'PROJECT',
  ProjectTask = 'PROJECT_TASK',
  Contract = 'CONTRACT'
}

export enum TimesheetWorkLocationType {
  UserResidence = 'USER_RESIDENCE',
  OfficeAddress = 'OFFICE_ADDRESS'
}

